export default __webpack_public_path__ + "static/media/trust.099e5c6f.svg";